/** Brevo-Platzhalter für die Vorschau lesbar machen. */
export function vorschauHtml(html: string): string {
  const basis = '<base target="_blank">';
  const ersetzt = html
    .replace(/\{\{\s*contact\.VORNAME\s*\}\}/gi, 'Alex')
    .replace(/\{\{\s*contact\.[A-Z_]+\s*\}\}/gi, '')
    .replace(/\{\{\s*(unsubscribe|mirror|update_profile)\s*\}\}/gi, '#');
  return /<head[^>]*>/i.test(ersetzt) ? ersetzt.replace(/<head([^>]*)>/i, `<head$1>${basis}`) : basis + ersetzt;
}
